export const validateNip = (nip?: string, mandatory = false): boolean => {
  if (nip == null || nip.length === 0) {
    return !mandatory;
  }

  const normalized = nip.replace(/[\s-]/g, '');

  if (!/^\d{10}$/.test(normalized)) {
    return false;
  }

  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  const digits = normalized.split('').map(Number);

  const sum = weights.reduce((acc, weight, i) => acc + weight * digits[i], 0);
  const control = sum % 11;

  if (control === 10) {
    return false;
  }

  return control === digits[9];
};
